import { Context, type Effect, Layer } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { EditorDocumentFailure, EditorDocumentHydration, EditorDocumentIdentity, EditorDocumentSnapshot, EditorFilesUpdate, EditorFoldersUpdate } from "./documents-model.ts";

export class EditorDocuments extends Context.Service<EditorDocuments, {
  readonly initial: EditorDocumentSnapshot;
  readonly read: Effect.Effect<EditorDocumentSnapshot>;
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<EditorDocumentSnapshot>>;
  readonly hydrate: (input: EditorDocumentHydration) => Effect.Effect<EditorDocumentSnapshot | undefined, EditorDocumentFailure>;
  readonly updateFiles: (identity: EditorDocumentIdentity, update: EditorFilesUpdate) => Effect.Effect<boolean, EditorDocumentFailure>;
  readonly updateFolders: (identity: EditorDocumentIdentity, update: EditorFoldersUpdate) => Effect.Effect<boolean, EditorDocumentFailure>;
}>()("workerstation/frontend/EditorDocuments") {}

export const EditorDocumentsTest = (ports: typeof EditorDocuments.Service) => Layer.succeed(EditorDocuments, ports);
